import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';

import {
  ADD_LEGAL_ENTITY_LABEL,
  ADD_LEGAL_ENTITY_PATH,
  TABLET,
} from '@app/constants';
import { useWindowSize } from '@app/hooks';

import { useAddLegalEntities } from '@pages/LegalEntities/AddLegalEntities/hooks/useAddLegalEntities';
import { useLegalEntitiesPageHeader } from '@pages/LegalEntities/LegalEntitiesList/hooks/useLegalEntitiesPageHeader';

import type { FC } from 'react';

export const LegalEntitiesPageHeader: FC = () => {
  const { hasUserRightForModuleView } = useLegalEntitiesPageHeader();
  const { hasUserRightToCreate } = useAddLegalEntities();
  const { innerWidth } = useWindowSize();

  const label = useMemo(
    () => (innerWidth <= TABLET ? '' : ADD_LEGAL_ENTITY_LABEL),
    [innerWidth]
  );

  if (!hasUserRightForModuleView || !hasUserRightToCreate) {
    return null;
  }

  return (
    <Link to={ADD_LEGAL_ENTITY_PATH}>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        data-testid="add-legal-entity"
      >
        {label}
      </Button>
    </Link>
  );
};
